<template>
  <v-container>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
       <div class="d-flex align-center">
         <v-btn @click="onBackClick" title="Go back" class="font-weight-bold text-capitalize mr-3" color="primary">
            <v-icon left>mdi-arrow-left</v-icon>Back
          </v-btn>
        <v-btn v-on="on" @click="onShowDialog" class="font-weight-bold text-capitalize" color="primary">
          Plan Switch History
        </v-btn>
         </div>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Switch History</span>
          <v-spacer></v-spacer>
          <v-btn text color="dark" @click="show_dialog_box = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headers" :items="history" class="mt-2 elevation-1" :mobile-breakpoint="0" ::items-per-page="25" :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }">
            <template v-slot:[`item.siNo`]="{ item }">
              {{
                history
                  .map(function(x) {
                    return x._id;
                  })
                  .indexOf(item._id) + 1
              }}
            </template>

            <template v-slot:[`item.updatedBy`]="{ item }">
              <span v-if="item.updatedBy"> {{ item.updatedBy.firstnameEn }} {{ item.updatedBy.lastnameEn }} </span>
            </template>
            <template v-slot:[`item.createdAt`]="{ item }">
              <span v-if="item.createdAt">
                {{ new Date(parseInt(item.createdAt)) | moment("MMM DD YYYY") }}
              </span>
            </template>
            <template v-slot:[`item.modeDetails`]="{ item }">
              <PlanSwtichHistoryFullDetails :history="item" />
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PlanSwtichHistoryFullDetails from "./PlanSwtichHistoryFullDetails.vue";
export default {
  components: { PlanSwtichHistoryFullDetails },
  mounted() {
    this.$root.$on("updatePlanswitchList", () => {
      this.loading = true;
      this.getPlanSwitchHistory();
    });
    this.$root.$on("closePlanSwitchWindows", () => {
      this.loading = true;
      this.show_dialog_box = false;
    });
  },
  methods: {
      onBackClick() {
      this.$router.go(-1);
    },
    onShowDialog() {
      this.getPlanSwitchHistory();
    },
    getPlanSwitchHistory() {
      this.$apollo
        .watchQuery({
          query: require("@/customer/components/salesOrder/api/getPlanSwitchHistory.graphql"),
          variables: {
            subscription: this.subscription,
            input: {
              skip: 0,
              limit: 25,
            },
          },
        })
        .refetch({
          variables: {
            subscription: this.subscription,
            input: {
              skip: 0,
              limit: 25,
            },
          },
        })
        .then(data => {
          if (data.data) {
            this.history = data.data.getPlanSwitchHistory.planSwitchHistories;
          }
        });
    },
  },
  props: {
    subscription: {
      require: true,
    },
  },
  watch: {
    subscription: {
      handler() {
        this.getPlanSwitchHistory();
      },
      deep: true,
    },
  },
  created() {
    this.getPlanSwitchHistory();
  },

  data: () => ({
    loading: true,
    history: [],
    show_dialog_box: false,
    headers: [
      {
        text: "Si No",
        value: "siNo",
        sortable: false,
      },
      { text: "Created At", value: "createdAt" },
      { text: "Status", value: "status" },
      { text: "From Plan", value: "from.packageTitleEn" },
      { text: "To Plan", value: "to.packageTitleEn" },
      { text: "Updated By", value: "updatedBy" },
      { text: "More Details", value: "modeDetails" },
    ],
  }),
};
</script>
